class LayoutService {
	constructor($timeout, $location, LocalStorageService, BuildingsService) {
		this.$timeout = $timeout;
		this.LocalStorageService = LocalStorageService;
		this.BuildingsService = BuildingsService;
	}

	getSelectedBuildingReference(value) {
		if (!value) {
			value = this.getDefaultSelectedBuildingRef();
		}
		if (value && typeof value === 'object') {
			return value.SchemeReference;
		}

		return value;
	}

	get isHome() {
		return !!!this.$location.$$url || this.$location.$$url === '/';
	}

	getDefaultSelectedBuildingRef() {
		const user = this.LocalStorageService.retrieve('userProfile');
		if (!user) {
			return null;
		}

		const { BuildingProfiles } = user;
		const buildingProfile = BuildingProfiles[0];
		const { SchemeReference } = buildingProfile;

		return SchemeReference;
	}

	setSelectedBuildingRef() {
		this.$timeout(() => {
			let selectedBuildingRef = this.getSelectedBuildingReference(
				this.LocalStorageService.retrieve('selectedBuildingRef')
			);

			angular
				.element('#homeMenu .list-group button')
				.each((i, ele) => angular.element(ele).removeClass('active'));
			let foundSelectedBuildingRef = this.BuildingsService.buildingsData.allBuildings.find((building) => {
				return building.SchemeReference === selectedBuildingRef;
			});

			if (foundSelectedBuildingRef) {
				const selectedBuildingButton = angular.element('#homeMenu .list-group button').toArray().find((ele) => {
					const ref = angular.element(ele).data('ref');
					return selectedBuildingRef === ref;
				});

				if (selectedBuildingButton) {
					angular.element(selectedBuildingButton).addClass('active');
				}
			}
		}, 500);
	}
}

export default /* @ngInject */ ($timeout, $location, LocalStorageService, BuildingsService) =>
	new LayoutService($timeout, $location, LocalStorageService, BuildingsService);
